import { WindowTitle } from "@saleor/components/WindowTitle";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import PaymentEventsComponent from "./views/PaymentEventsList";

const PaymentEventsList: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));

  return <PaymentEventsComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Payment Events",
          description: "payment events section"
        })}
      />
      <Routes>
        <Route path={""} element={<PaymentEventsList />} />
      </Routes>
    </>
  );
};

export default Component;
